import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/subscription/")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW", "SUBSCRIPTION_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <Navigate to="/subscription/overview" />,
});

export { Route };
